// The organisation banks with a small, fixed set of banks, and almost always
// just one. A free-text bank name invited spelling variants ("Awash Bank" vs
// "Awash") that split one bank into several on the export. Awash is the default
// because it is the one in use.
//
// Shared by the account holder form and the CSV import so the two cannot drift.
export const BANK_CHOICES = [
    { id: 'Awash', name: 'Awash' },
    { id: 'CBE', name: 'CBE' },
    { id: 'BOA', name: 'BOA' },
];

export const DEFAULT_BANK = 'Awash';

export const isKnownBank = name => BANK_CHOICES.some(choice => choice.id === name);
